module.exports = __webpack_public_path__ + "static/hero-desktop-c094939409559c0dc9dfa16c285fbe34.png";